import React, {useState} from 'react';
import {GetServerSideProps} from 'next';
import {PageSearchComp, ssrSearch} from '@graphql/generated/page';

import BackBar from '@components/Layout/BackBar';
import SearchBar from '@components/Search/Searchbar';
import SearchStores from '@components/Search/SearchStores';
import SearchCategories from '@components/Search/SearchCategories';
import SearchDeliveryOption from '@components/Search/SearchDeliveryOption';

export const getServerSideProps: GetServerSideProps = async ctx => {
  const {props} = await ssrSearch.getServerPage({}, ctx);
  return {props};
};

const Search: PageSearchComp = ({data: {categories}}) => {
  const [searchString, setSearchString] = useState<string>('');

  return (
    <main className="pb-12">
      <div className="sticky top-0 left-0 right-0 max-w-md mx-auto bg-white z-70">
        <BackBar alignment="justify-center"></BackBar>
        <SearchBar searchString={searchString} setSearchString={setSearchString} placeholder="Search for a store" />
        {searchString && <SearchDeliveryOption />}
      </div>

      {searchString ? <SearchStores searchString={searchString} /> : <SearchCategories categories={categories} />}
    </main>
  );
};

export default Search;
